
import Vue from 'vue';
export default Vue.extend({
  props: {
    tableData: {
      type: Object,
    },
    columnHead: {
      type: Boolean,
    },
  },
  methods: {
    transformContent(content: any) {
      return content
        .replace(/(?:\r\n|\r|\n)/g, '<br />')
        .replace('<', '&lt;')
        .replace('>', '&gt;');
    },
  },
});
